import { useFeatureIsOn } from '@growthbook/growthbook-react';

/**
 * Whether the GIP form should use the new audit-reports metadata API.
 * Defaults to false (legacy logger `/v2/audit/gip/*`) when the flag is missing.
 */
export function useGipFormNewApi() {
  return useFeatureIsOn('app__gip_form_new_api');
}
